import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "next-themes";
import { App } from "./app";
import { Toaster } from "./components/ui/sonner";
import "./styles/index.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      storageKey="weblinkpong-admin-theme"
    >
      <App />
      <Toaster richColors closeButton position="top-right" duration={7000} />
    </ThemeProvider>
  </StrictMode>,
);
